function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconFoodFineDiningFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.847 13.694a.9.9 0 01-.541 1.152 4.094 4.094 0 00-2.46 2.46.9.9 0 01-1.693-.612 5.894 5.894 0 013.541-3.54.9.9 0 011.152.54z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.76 9h.003a11.807 11.807 0 017.906 3.035 1 1 0 11-1.338 1.486A9.807 9.807 0 0014.76 11c-5.156.007-9.414 3.973-9.763 9.069a1 1 0 11-1.996-.137C3.425 13.777 8.563 9.006 14.76 9zM23.03 17c.056.464.19.908.396 1.308l.097.187c.486.836 1.237 1.357 2.032 1.495h.827c.815-.12 1.588-.644 2.088-1.496l.1-.194c.206-.396.342-.838.4-1.3h-5.94zM21 16.503c0-.709.535-1.503 1.444-1.503h7.112c.909 0 1.444.794 1.444 1.503 0 .863-.184 1.717-.542 2.49v.02l-.11.215c-.77 1.497-2.152 2.553-3.776 2.754l-.061.008h-.5l-.06.067-.523-.065c-1.623-.2-3.011-1.257-3.78-2.76l-.11-.214v-.021A5.97 5.97 0 0121 16.503z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26 21a1 1 0 011 1v3a1 1 0 11-2 0v-3a1 1 0 011-1z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 26a1 1 0 011-1h4a1 1 0 110 2h-4a1 1 0 01-1-1zM1 23a1 1 0 011-1h20a1 1 0 110 2H2a1 1 0 01-1-1zM15 6a1 1 0 011 1v2a1 1 0 11-2 0V7a1 1 0 011-1z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 7a1 1 0 011-1h4a1 1 0 110 2h-4a1 1 0 01-1-1z",
    fill: props.color
  }));
}

export default SvgIconFoodFineDiningFilled;